import React, { useState } from 'react';
import { Canvas } from '@react-three/fiber';
import SkullScene from './components/SkullScene';
import './App.css';

function App() {
  const [targetPosition, setTargetPosition] = useState([0, 0, 0]);

  const handleHover = (x, y, z) => {
    setTargetPosition([x, y, z]);
  };

  return (
    <div className="app-container">
      {/* Left: 3D model area */}
      <div className="canvas-container">
        <div className="skull">
          <Canvas>
            <SkullScene targetPosition={targetPosition} />
          </Canvas>
        </div>
        {/* Text or images below the skull */}
        <div className="skull-info">
        <p>Oct 15th - Nov 1st 4pm-12am nightly</p>
        <p>15405 Juston Blvd. LA, CA 91400</p>
          <img
            src="/assets/hayride2024.png" // Replace with your image path
            alt="Skull Details"
            className="skull-image"
          />
        </div>
      </div>

      {/* Right: Menu buttons */}
      <div className="menu-container">
        <div
          className="menu-button"
          onMouseEnter={() => handleHover(1, -0.75, 0)}
          onMouseLeave={() => handleHover(0, 0, 0)}
        >
          Locations
        </div>
        <div
          className="menu-button"
          onMouseEnter={() => handleHover(1, -2, 0)}
          onMouseLeave={() => handleHover(0, 0, 0)}
        >
          Schedule
        </div>
        <div
          className="menu-button"
          onMouseEnter={() => handleHover(1, -3, 0)}
          onMouseLeave={() => handleHover(0, 0, 0)}
        >
          Buy Tickets
        </div>
        <div
          className="menu-button"
          onMouseEnter={() => handleHover(1, -4, 0)}
          onMouseLeave={() => handleHover(0, 0, 0)}
        >
          Contact
        </div>
        <div className='followus'>
          <p>
            Follow Us
          </p>
        </div>
        <div className="social-media">
          <a
            href="https://x.com"
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => handleHover(1, -4, 1)} // Adjust coordinates for Twitter
            onMouseLeave={() => handleHover(0, 0, 0)} // Reset position
          >
            <img src="assets/X-logo-transparent-white.png" alt="Twitter" className="social-icon" />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => handleHover(1, -4.5, 1)} // Adjust coordinates for Facebook
            onMouseLeave={() => handleHover(0, 0, 0)} // Reset position
          >
            <img src="assets/facebook_logo_icon.svg" alt="Facebook" className="social-icon" />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => handleHover(1, -5, 1)} // Adjust coordinates for Instagram
            onMouseLeave={() => handleHover(0, 0, 0)} // Reset position
          >
            <img src="assets/instagram_instagram_logo_icon.svg" alt="Instagram" className="social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
